// extracted by mini-css-extract-plugin
module.exports = {"container":"Sports360_container__3SmVZ","pagebg":"Sports360_pagebg__osOle","headerLogo":"Sports360_headerLogo__2w2UU","buffContainer":"Sports360_buffContainer__1KIHT"};